import { z } from 'zod'

export const parseDateSearchString = (value: string) => {
  const trimmed = value.trim()

  if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
    try {
      const parsed = JSON.parse(trimmed)

      if (typeof parsed === 'string') {
        return parsed
      }
    } catch {
      return value
    }
  }

  return value
}

export const parseIsoDateSearchParam = (value: unknown): string | undefined => {
  if (value instanceof Date && !Number.isNaN(value.valueOf())) {
    return value.toISOString()
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const normalized =
      typeof value === 'string' ? parseDateSearchString(value) : value
    const parsed = new Date(normalized)

    if (!Number.isNaN(parsed.valueOf())) {
      return parsed.toISOString()
    }
  }

  return undefined
}

export const isoDateTimeSearchParam = z.preprocess(
  parseIsoDateSearchParam,
  z.iso.datetime(),
)
